import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// Buzz Finder
import SignIn from "./Pages/SignIn";
import ResetPassword from "./Pages/ResetPassword";
import ResetPasswordForm from "./Pages/ResetPasswordForm";
import DashBoard from "./Pages/DashBoard";
import DashBoardDaily from "./Pages/DashBoard/daily";
import DashBoardHourly from "./Pages/DashBoard/hourly";
import DashBoardDetail from "./Pages/DashBoard/detail";
import Retweet from "./Pages/Retweets/analyze";
import Keywords from "./Pages/Keywords/analyze";
import Users from "./Pages/Users/analyze";
import Tweets from "./Pages/Tweets";
import DataDownload from "./Pages/DataDownload";
import Group from "./Pages/Group";
import RetweetMonthly from "./Pages/Retweets/monthly";
import RetweetDaily from "./Pages/Retweets/daily";
import RetweetDetail from "./Pages/Retweets/detail";
import KeywordMonthly from "./Pages/Keywords/monthly";
import KeywordDaily from "./Pages/Keywords/daily";
import KeywordDetail from "./Pages/Keywords/detail";
import UserDetail from "./Pages/UserDetail";
import UserSetting from "./Pages/UserSetting";
import ChangePassword from "./Pages/ChangePassword";
import DailyTopicMail from "./Pages/DailyTopicMail";
import CreateGroup from "./Pages/CreateGroup";
import ConfigFilterHorse from "./Pages/Config/FilterHorse";
import ConfigFilterUsers from "./Pages/Config/Users";
import ConfigFilterUserCreate from "./Pages/Config/Users/create";
import ConfigFilterUserEdit from "./Pages/Config/Users/edit";
import ConfigCondition from "./Pages/Config/Condition";
import ConfigSetting from "Pages/Config/Setting";
import LimitRelease from "Pages/LimitRelease";
import NotFound from './Pages/404';
// Add 2023.03.31 投稿分類
import AnalysisTask from "Pages/AnalysisTask";
import AnalysisTaskCreate from "Pages/AnalysisTask/create";
import AnalysisTaskDetail from "Pages/AnalysisTask/detail";
import AnalysisTaskCopy from "Pages/AnalysisTask/copy";
import AnalysisTaskEdit from "Pages/AnalysisTask/edit";
// Buzz Finder Media
import MediaDashBoard from "./Pages/Media/DashBoard";
import MediaDashBoardDaily from "./Pages/Media/DashBoard/daily";
import MediaDashBoardHourly from "./Pages/Media/DashBoard/hourly";
import MediaDashBoardDetail from "./Pages/Media/DashBoard/detail";
import Medias from "./Pages/Media/Medias";
import MediaDataDownload from "./Pages/Media/DataDownload";
import MediaConfigUsers from "./Pages/Media/Config/Users";
import MediaConfigUserCreate from "./Pages/Media/Config/Users/create";
import MediaConfigUserEdit from "./Pages/Media/Config/Users/edit";
import MediaConfigChangePassword from "./Pages/Media/Config/ChangePassword";
import MediaConfigSetting from "Pages/Media/Config/Setting";
// Buzz Finder analysis
import DictionarySettingMenu from "./Pages/DictionarySetting/Menu";
import DictionarySettingNoise from "./Pages/DictionarySetting/Noise";
import DictionarySettingNoiseCreate from "./Pages/DictionarySetting/Noise/create";
import DictionarySettingNoiseEdit from "./Pages/DictionarySetting/Noise/edit";
import DictionarySettingClassification from "./Pages/DictionarySetting/Classification";
import DictionarySettingClassificationCreate from "./Pages/DictionarySetting/Classification/create";
import DictionarySettingClassificationEdit from "./Pages/DictionarySetting/Classification/edit";
// Buzz Finder Admin
import AdminSignIn from "./Pages/Admin/SignIn";
import AdminMenu from "./Pages/Admin/Menu";
import AdminAdministrator from "./Pages/Admin/Administrator";
import AdminAdministratorCreate from "./Pages/Admin/Administrator/create";
import AdminAdministratorEdit from "./Pages/Admin/Administrator/edit";
import AdminAccount from "./Pages/Admin/Accounts";
import AdminAccountCreate from "./Pages/Admin/Accounts/create";
import AdminAccountEdit from "./Pages/Admin/Accounts/edit";
import AdminAccountReserve from "./Pages/Admin/Accounts/reserve";
import AdminCsvDownload from "./Pages/Admin/CsvDownload";
import AdminCollectionThemes from "./Pages/Admin/CollectionThemes";
import AdminCollectionThemesCreate from "./Pages/Admin/CollectionThemes/create";
import AdminCollectionThemesEdit from "./Pages/Admin/CollectionThemes/edit";
import AdminInformation from "./Pages/Admin/Information";
import AdminInformationCreate from "./Pages/Admin/Information/create";
import AdminInformationEdit from "./Pages/Admin/Information/edit";
import AdminCustomerScreen from "./Pages/Admin/CustomerScreen";
import AdminCustomerScreenView from "./Pages/Admin/CustomerScreen/view";
// import AdminKeyword from "./Pages/Admin/Keyword";
import AdminLog from "./Pages/Admin/Log";
import AdminDtm from "./Pages/Admin/Dtm";
import AdminDtmCreate from "./Pages/Admin/Dtm/create";
import AdminDtmEdit from "./Pages/Admin/Dtm/edit";
import AdminDtmSettings from "./Pages/Admin/Dtm/settings";
import AdminInformationUrls from "./Pages/Admin/InformationUrls";
import AdminInformationUrlsCreate from "./Pages/Admin/InformationUrls/create";
import AdminInformationUrlsEdit from "./Pages/Admin/InformationUrls/edit";
import AdminResetPassword from "./Pages/Admin/ResetPassword";
import AdminResetPasswordForm from "./Pages/Admin/ResetPasswordForm";
import AdminMediaAccounts from "./Pages/Admin/MediaAccounts";
import AdminMediaAccountGroups from "./Pages/Admin/MediaAccounts/groups";
import AdminMediaAccountGroupCreate from "./Pages/Admin/MediaAccounts/create";
import AdminMediaAccountGroupEdit from "./Pages/Admin/MediaAccounts/edit";
import AdminMediaTypes from "./Pages/Admin/MediaTypes";
import AdminMediaTypeCreate from "./Pages/Admin/MediaTypes/create";
import AdminMediaTypeEdit from "./Pages/Admin/MediaTypes/edit";
// Buzz Finder Upload
import UploadSignIn from "./Pages/Upload/SignIn";
import UploadResetPassword from "./Pages/Upload/ResetPassword";
import UploadResetPasswordForm from "./Pages/Upload/ResetPasswordForm";
import UploadAccounts from "./Pages/Upload/Accounts";
import UploadAccountGroups from "./Pages/Upload/Accounts/groups";
import UploadAccountGroupInfo from "./Pages/Upload/Accounts/info";
import UploadConfigSetting from "./Pages/Upload/Config/Setting";
import UploadConfigUsers from "./Pages/Upload/Config/Users";
import UploadConfigUserCreate from "./Pages/Upload/Config/Users/create";
import UploadConfigUserEdit from "./Pages/Upload/Config/Users/edit";
import UploadChangePassword from "./Pages/Upload/ChangePassword";

const App = () => {
  return (
    <Router>
      <Switch>
        {/* 一般画面 */}
        <Route path="/" component={SignIn} exact />
        <Route path="/password_reset/request" component={ResetPassword} exact />
        <Route path="/dashboard/daily" component={DashBoardDaily} />
        <Route path="/dashboard/hourly" component={DashBoardHourly} exact />
        <Route path="/dashboard/details" component={DashBoardDetail} exact />
        <Route path="/group/create" component={CreateGroup} />
        <Route path="/retweets/monthly" component={RetweetMonthly} />
        <Route path="/retweets/daily" component={RetweetDaily} />
        <Route path="/retweets/details" component={RetweetDetail} />
        <Route path="/keywords/monthly" component={KeywordMonthly} />
        <Route path="/keywords/daily" component={KeywordDaily} />
        <Route path="/keywords/details" component={KeywordDetail} />
        <Route path="/users/details" component={UserDetail} />
        <Route path="/user-setting" component={UserSetting} />
        <Route path="/config/password" component={ChangePassword} />
        <Route path="/config/dtm" component={DailyTopicMail} />
        <Route path="/config/contract" component={ConfigCondition} />
        <Route path="/config/user" component={ConfigFilterUsers} />
        <Route path="/config/keyword" component={ConfigFilterHorse} />
        <Route path="/config/create_user" component={ConfigFilterUserCreate} />
        <Route path="/config/update_user/:id" component={ConfigFilterUserEdit} />
        {/* Add 2023.03.31 一般画面 - 投稿分類管理 */}
        <Route path="/config/dictionarysetting/menu" component={DictionarySettingMenu} />
        <Route path="/config/dictionarysetting/noise" component={DictionarySettingNoise} exact />
        <Route path="/config/dictionarysetting/noise/create" component={DictionarySettingNoiseCreate} />
        <Route path="/config/dictionarysetting/noise/edit/:id" component={DictionarySettingNoiseEdit} />
        <Route path="/config/dictionarysetting/classification" component={DictionarySettingClassification} exact />
        <Route path="/config/dictionarysetting/classification/create" component={DictionarySettingClassificationCreate} />
        <Route path="/config/dictionarysetting/classification/edit/:id" component={DictionarySettingClassificationEdit} />
        <Route path="/config" component={ConfigSetting} />
        <Route path="/limit_release" component={LimitRelease} />
        <Route path="/password_reset/confirm" component={ResetPasswordForm} />
        <Route path="/retweets" component={Retweet} />
        <Route path="/dashboard" component={DashBoard} exact />
        <Route path="/keywords" component={Keywords} />
        <Route path="/users" component={Users} />
        <Route path="/tweets" component={Tweets} />
        <Route path="/download" component={DataDownload} />
        <Route path="/group" component={Group} />
        {/* Add 2023.03.31 投稿分類 */}
        <Route path="/analysistask" component={AnalysisTask} exact />
        <Route path="/analysistask/detail/:id" component={AnalysisTaskDetail} />
        <Route path="/analysistask/create/:type" component={AnalysisTaskCreate} />
        <Route path="/analysistask/copy/:id" component={AnalysisTaskCopy} />
        <Route path="/analysistask/edit/:id" component={AnalysisTaskEdit} />
        {/* 一般画面 - その他メディア */}
        <Route path="/media/dashboard" component={MediaDashBoard} exact />
        <Route path="/media/dashboard/daily" component={MediaDashBoardDaily}  />
        <Route path="/media/dashboard/hourly" component={MediaDashBoardHourly} exact />
        <Route path="/media/dashboard/details" component={MediaDashBoardDetail} exact />
        <Route path="/media/medias" component={Medias} />
        <Route path="/media/download" component={MediaDataDownload} />
        <Route path="/media/config/user" component={MediaConfigUsers} />
        <Route path="/media/config/create_user" component={MediaConfigUserCreate} />
        <Route path="/media/config/update_user/:id" component={MediaConfigUserEdit} />
        <Route path="/media/config/password" component={MediaConfigChangePassword} />
        <Route path="/media/config" component={MediaConfigSetting} />
        {/* 管理画面 */}
        <Route path="/admin/" component={AdminSignIn} exact />
        <Route path="/admin/top" component={AdminMenu} exact />
        <Route path="/admin/administrator" component={AdminAdministrator} exact />
        <Route path="/admin/administrator/create" component={AdminAdministratorCreate} />
        <Route path="/admin/administrator/edit/:id" component={AdminAdministratorEdit} />
        <Route path="/admin/account" component={AdminAccount} exact />
        <Route path="/admin/account/create" component={AdminAccountCreate} />
        <Route path="/admin/account/edit/:id" component={AdminAccountEdit} />
        <Route path="/admin/account/reserve/:accountId/:reserveId" component={AdminAccountReserve} />
        <Route path="/admin/csv_download" component={AdminCsvDownload} />
        <Route path="/admin/collectionthemes" component={AdminCollectionThemes} exact />
        <Route path="/admin/collectionthemes/create" component={AdminCollectionThemesCreate} />
        <Route path="/admin/collectionthemes/edit/:id" component={AdminCollectionThemesEdit} />
        <Route path="/admin/information" component={AdminInformation} exact />
        <Route path="/admin/information/create" component={AdminInformationCreate} />
        <Route path="/admin/information/edit/:id" component={AdminInformationEdit} />
        <Route path="/admin/customerScreen" component={AdminCustomerScreen} exact />
        <Route path="/admin/customerScreen/view" component={AdminCustomerScreenView} />
        {/* <Route path="/admin/keyword" component={AdminKeyword} /> */}
        <Route path="/admin/log" component={AdminLog} />
        <Route path="/admin/dtm" component={AdminDtm} exact />
        <Route path="/admin/dtm/create" component={AdminDtmCreate} />
        <Route path="/admin/dtm/edit/:id" component={AdminDtmEdit} />
        <Route path="/admin/dtm/settings" component={AdminDtmSettings} />
        <Route path="/admin/informationUrls" component={AdminInformationUrls} exact />
        <Route path="/admin/informationUrls/create" component={AdminInformationUrlsCreate} />
        <Route path="/admin/informationUrls/edit/:id" component={AdminInformationUrlsEdit} />
        <Route path="/admin/password_reset/request" component={AdminResetPassword} />
        <Route path="/admin/password_reset/confirm" component={AdminResetPasswordForm} />
        <Route path="/admin/media/accounts" component={AdminMediaAccounts} exact />
        <Route path="/admin/media/accounts/group/:accountId" component={AdminMediaAccountGroups} exact />
        <Route path="/admin/media/accounts/group/:accountId/create" component={AdminMediaAccountGroupCreate} />
        <Route path="/admin/media/accounts/group/:accountId/edit/:groupId" component={AdminMediaAccountGroupEdit} />
        <Route path="/admin/media/types" component={AdminMediaTypes} exact />
        <Route path="/admin/media/types/create" component={AdminMediaTypeCreate} />
        <Route path="/admin/media/types/edit/:typeId" component={AdminMediaTypeEdit} />
        {/* アップロード画面 */}
        <Route path="/upload/" component={UploadSignIn} exact />
        <Route path="/upload/top" component={UploadAccounts} exact />
        <Route path="/upload/top/group/:accountId" component={UploadAccountGroups} exact />
        <Route path="/upload/top/group/:accountId/info/:groupId" component={UploadAccountGroupInfo} />
        <Route path="/upload/config" component={UploadConfigSetting} exact />
        <Route path="/upload/config/user" component={UploadConfigUsers} exact />
        <Route path="/upload/config/user/create" component={UploadConfigUserCreate} />
        <Route path="/upload/config/user/edit/:id" component={UploadConfigUserEdit} />
        <Route path="/upload/config/password" component={UploadChangePassword} exact />
        <Route path="/upload/password_reset/request" component={UploadResetPassword} />
        <Route path="/upload/password_reset/confirm" component={UploadResetPasswordForm} />
        {/*
        <Route path="/admin/xxx" component={AdminXXX} />
        */}
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};

export default App;
